// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a3818dc72a5e937c940a","655":"54cc1a529abbb61e458b"}[chunkId] + ".js";
};